/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { isMobile } from 'react-device-detect'

// css
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { ChatFontSize, SendMessageToEnterType } from '@interface/chat'
import { schema_user_chat_option } from 'adv-lib/src/models/chat/user-chat-option'
import { ChatSettingLabel, ChatSettingWrap } from './index.style'

const ChatSettingPopup: React.FC = props => {
  const { authStore } = useRootStore()
  const { userInfo } = authStore

  const { chatOption = {} } = userInfo
  const {
    fontSize, showChattingPreviewMainMessage, sendMessageToEnter, showPopularSearchTerm
  } = chatOption as schema_user_chat_option

  let enableSendToEnter = false
  switch (sendMessageToEnter) {
    case SendMessageToEnterType.M_OFF_PC_ON:
      // eslint-disable-next-line
      enableSendToEnter = isMobile ? false : true
      break
    case SendMessageToEnterType.M_ON_PC_ON:
      // eslint-disable-next-line
      enableSendToEnter = isMobile ? true : true
      break
    case SendMessageToEnterType.M_ON_PC_OFF:
      // eslint-disable-next-line
      enableSendToEnter = isMobile ? true : false
      break
    case SendMessageToEnterType.M_OFF_PC_OFF:
      // eslint-disable-next-line
      enableSendToEnter = isMobile ? false : false
      break
  }


  const toggleUserChatOption = (key: string) => {
    if (key === 'fontSize') {
      if (fontSize === ChatFontSize.SMALL) {
        authStore.changeUserChatOption(key, ChatFontSize.LARGE)
      } else {
        authStore.changeUserChatOption(key, ChatFontSize.SMALL)
      }
    } else if (key === 'sendMessageToEnter') {
      switch (sendMessageToEnter) {
        case SendMessageToEnterType.M_OFF_PC_ON:
          if (isMobile) {
            authStore.changeUserChatOption(key, SendMessageToEnterType.M_ON_PC_ON)
          } else {
            authStore.changeUserChatOption(key, SendMessageToEnterType.M_OFF_PC_OFF)
          }
          break
        case SendMessageToEnterType.M_ON_PC_ON:
          if (isMobile) {
            authStore.changeUserChatOption(key, SendMessageToEnterType.M_OFF_PC_ON)
          } else {
            authStore.changeUserChatOption(key, SendMessageToEnterType.M_ON_PC_OFF)
          }
          break
        case SendMessageToEnterType.M_ON_PC_OFF:
          if (isMobile) {
            authStore.changeUserChatOption(key, SendMessageToEnterType.M_OFF_PC_OFF)
          } else {
            authStore.changeUserChatOption(key, SendMessageToEnterType.M_ON_PC_ON)
          }
          break
        case SendMessageToEnterType.M_OFF_PC_OFF:
          if (isMobile) {
            authStore.changeUserChatOption(key, SendMessageToEnterType.M_ON_PC_OFF)
          } else {
            authStore.changeUserChatOption(key, SendMessageToEnterType.M_OFF_PC_ON)
          }
          break
      }
    } else if (key === 'showChattingPreviewMainMessage') {
      authStore.changeUserChatOption(key, !chatOption[key])
    } else if (key === 'showPopularSearchTerm') {
      // const currentVisibility = globalStore.visiblePopularSearchTerm
      // globalStore.setVisiblePopularSearchTerm(!currentVisibility)
      authStore.changeUserChatOption(key, !chatOption[key])
    }
  }

  return (
    <Fragment>
      <ChatSettingWrap>
        <ul className="setting-list">
          <li className="setting-list--item">
            <p className="setting-tit">엔터키 전송</p>
            <input
              type="checkbox"
              id="sendMessageToEnter"
              name="sendMessageToEnter"
              value={enableSendToEnter ? 1 : 0}
              className="setting-input"
              checked={enableSendToEnter}
              disabled />
            <ChatSettingLabel
              htmlFor="sendMessageToEnter"
              className="on-off-wrap"
              onClick={() => toggleUserChatOption('sendMessageToEnter')}>
              <span className="on">ON</span>
              <span className="off">OFF</span>
            </ChatSettingLabel>
          </li>
          <li className="setting-list--item">
            <p className="setting-tit">폰트 크기</p>
            <input
              type="checkbox"
              id="chatFontSize"
              name="chatFontSize"
              value={fontSize}
              className="setting-input"
              checked={fontSize === ChatFontSize.SMALL}
              disabled />
            <ChatSettingLabel htmlFor="chatFontSize" className="on-off-wrap" onClick={() => toggleUserChatOption('fontSize')}>
              <span className="on">작게</span>
              <span className="off">크게</span>
            </ChatSettingLabel>
          </li>
          <li className="setting-list--item">
            <p className="setting-tit">
              알림 설정
              <span className="setting-sub-txt">채팅 내용을 토스트 메시지로 받습니다.</span>
            </p>
            <input
              type="checkbox"
              id="showChattingPreviewMainMessage"
              name="showChattingPreviewMainMessage"
              value={showChattingPreviewMainMessage === true ? 1 : 0}
              className="setting-input"
              checked={showChattingPreviewMainMessage}
              disabled />
            <ChatSettingLabel htmlFor="showChattingPreviewMainMessage" className="on-off-wrap" onClick={() => toggleUserChatOption('showChattingPreviewMainMessage')}>
              <span className="on">ON</span>
              <span className="off">OFF</span>
            </ChatSettingLabel>
          </li>
          {isMobile &&
            <li className="setting-list--item">
              <p className="setting-tit">
                이슈 키워드
              </p>
              <input
                type="checkbox"
                id="showPopularSearchTerm"
                name="showPopularSearchTerm"
                value={showPopularSearchTerm === true ? 1 : 0}
                className="setting-input"
                checked={showPopularSearchTerm}
                disabled/>
              <ChatSettingLabel htmlFor="showPopularSearchTerm" className="on-off-wrap"
                                onClick={() => toggleUserChatOption('showPopularSearchTerm')}>
                <span className="on">ON</span>
                <span className="off">OFF</span>
              </ChatSettingLabel>
            </li>
          }
        </ul>
      </ChatSettingWrap>
    </Fragment>
  )
}

export default observer(ChatSettingPopup)
